import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();
  const imagekit = import.meta.env.VITE_IMAGEKIT_URL;
  const transactionCode = localStorage.getItem('transactionCode');

  // Redirect to dashboard if already authenticated
  if (isAuthenticated && transactionCode) {
    return <Navigate to="/transaction-code" replace />;
  } else if (isAuthenticated && !transactionCode) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <div
        className="min-h-screen bg-black text-white flex flex-col p-5 overflow-hidden"
        style={{
          backgroundImage: `url(${imagekit}/login/bg.webp)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Rotated background image */}
        {/* <div
          className="absolute inset-0 z-0  origin-center"
         
        /> */}

        {/* Logo */}
        <img src={`${imagekit}/login/logo.svg`} alt="" className="w-40 relative z-10" />

        {/* Centered Section */}
        <div className="flex-grow flex-center relative z-10">
          <div className="relative max-w-[560px] w-full mx-auto flex-center flex-col">
            <img src={`${imagekit}/login/logo.svg`} alt="" className="w-80 relative z-10 mb-10" />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
